import { Strings } from './Strings';

export const getEsEsStrings = () : Strings => ({
  SESSION_EXPIRED: 'Sesión caducada!',
  BOOLEAN_ATTRIBUTE_YES: 'Sí',
  BOOLEAN_ATTRIBUTE_NO: 'No',
  PAGE_NOT_FOUND: 'Página no encontrada...',
  COLLECTIONS_HEADER_LABEL: 'Colecciones',
  SEARCH_HEADER_LABEL: 'Buscar',
  INFORMATION_SLIDER_BUTTON: '+ INFORMACIÓN',
  NEXT_SLIDER_SPAN: 'Próxima',
  PREVIOUS_SLIDER_SPAN: 'Previa',
  SPOTLIGHT_OBJECTS_LABEL: 'Botas de equitación a medida, fabricadas exclusivamente para usted.',
  MENU_FOOTER_LABEL: 'Menú',
  FILTERS_LABEL: 'Filtros',
  VARIANTS_OBJECT_LABEL: 'Variantes',
  ADD_TO_CART_OBJECT_LABEL: 'Añadir al carrito',
  PRODUCT_LIST_ORDER_LABEL: 'LISTA DE PRODUCTOS',
  ORDER_TOTAL_LABEL: 'Total del carrito de compras',
  CHECKOUT_ORDER_BUTTON: 'CONTINUAR A LA COMPROBACIÓN',
  PREVIEW_ORDER_BUTTON: 'Vista Previa del Pedido',
  VARIANT_ORDER_ITEM_LABEL: 'Variante',
  QUANTITY_ORDER_ITEM_LABEL: 'Cantidad',
  PRODUCT_ADDED_TOAST_LABEL: 'Producto añadido!',
  CHECKOUT_ORDER_TOAST_LABEL: '¡Solicitud enviada!',
  COMPONENTS_OBJECT_LABEL: 'Componentes',
  ORDER_DETAIL_TITLE_LABEL: 'Detalle de la orden',
  ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL: 'Atributos personalizados',
  SUBMIT_LABEL: 'Entregar',
  ADD_TO_CART_LABEL: 'Añadir artículo al carrito',
  CUSTOMIZED_VARIANT: 'Personalizada',
  PRODUCTLIST: 'Lista de productos',
  PRODUCTLISTDOCLABEL_ITEMNAME: 'Nombre del árticulo',
  PRODUCTLISTDOCLABEL_VARIATION: 'Variación',
  PRODUCTLISTDOCLABEL_COLLECTION: 'Recopilación',
  PRODUCTLISTDOCLABEL_COMPOSITION: 'Composición',
  PRODUCTLISTDOCLABEL_QUANTITY: 'Cantidad',
  NAVIGATE_BACK: 'Regresa',
  REMOVE: 'Eliminar',
  CLEAR_CART: 'Vaciar carrito',
  RESULTS_FOR: 'resultados para',
  NO_CONTENT_TEXT: 'Imagen no disponible',
  STANDARD: 'Estándar',
  PARTS: 'Partes',
  CUSTOMIZATIONS: 'Personalizaciones',
  PRICE: 'Precio',
  TOTAL: 'Total',
  QUANTITY: 'Cantidad',
  MEASURES: 'Medidas',
  CUSTOM_ATTRIBUTES: 'Atributos personalizados',
  LOGIN_SUCCESSFUL: 'Inicio de sesión exitosa',
  LOGIN_CREDENTIALS_NOT_VALID: 'Credenciales no válidas',
  LOGIN_UNKNOWN_ERROR: 'Error desconocido',
  LOGIN_RECOVER_PASSWORD: 'Recuperar contraseña',
  LOGIN_CHANGE_PASSWORD: 'Cambiar la contraseña',
  LOGIN_USERNAME: 'Nombre de usuario',
  LOGIN_PASSWORD: 'Contraseña',
  LOGIN_OLD_PASSWORD: 'Contraseña anterior',
  LOGIN_NEW_PASSWORD: 'Nueva contraseña',
  LOGIN_NEW_PASSWORD_REPEAT: 'repita la nueva contraseña',
  LOGIN_ACTION_LOGIN: 'Acceso',
  RECOVER_PASSWORD_MESSAGE: 'Se ha enviado una nueva contraseña a su correo electrónico.',
  CHANGE_PASSWORD_SUCCESSFUL_MESSAGE: 'El cambio de contraseña fue exitoso.',
  CHANGE_PASSWORD_ERROR_MESSAGE: 'Se produjo un error al intentar cambiar la contraseña.',
  CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE: 'La nueva contraseña debe coincidir con la nueva contraseña repetida.',
  GO_BACK_ACTION: 'Atrás',
  CONFIRM_ACTION: 'Confirmar',
  SIGN_OUT_ACTION: 'Desconectar',
  OK_ACTION: 'De acuerdo',
  CANCEL_ACTION: 'Cancelar',
  RETRY_ACTION: 'Rever',
  RESEND_ACTION: 'Reenviar',
  ERROR_LABEL: 'Error',
  SUCCESS_LABEL: 'Éxito',
  ORDER_ERROR_MESSAGE: 'Se produjo un error al intentar enviar el pedido.',
  ORDER_SUCCESS_MESSAGE: 'El envío del pedido fue exitoso.',
  DEMO_ORDER_ERROR_MESSAGE: 'Proceso de pedido en modo demostración completado con éxito.',
  DEMO_ORDER_SUCCESS_MESSAGE: 'Proceso de pedido en modo demostración completado con éxito.',
  VALIDATION_POP_UP_TITLE: 'Validación de correo electrónico',
  VALIDATION_POP_UP_MESSAGE: 'Por favor inserte el código enviado a su correo electrónico:',
  VALIDATION_POP_UP_ERROR: 'El código no coincide',
  DEMO_WARNING: '¡Solo para fines de demostración!',
  REPORT_ORDER_INFO_TITLE: 'Datos del pedido',
  REPORT_TITLE_DESCRIPTION: 'Descripción',
  REPORT_TITLE_VALUE: 'Valor',
  REPORT_TITLE_QUANTITY: 'Cant.',
  REPORT_TITLE_PRICE: 'Precio',
  REPORT_TITLE_SCREENSHOT: 'Captura de pantalla',
  REPORT_TITLE_KEY: 'Nome',
});
